'use es6';

import { createSelector } from 'reselect';
import { hasZorseDashboardAccess, isUngatedForEscalations } from 'conversations-thread-data/auth/public/selectors';
import { getZorseInboxes } from '../inboxSelectors/getZorseInboxes';
const getInboxId = (__, props) => props.inboxId;
export const hasEscalationAccess = createSelector([isUngatedForEscalations, hasZorseDashboardAccess, getInboxId, getZorseInboxes], (isUngated, hasAccess, inboxId, zorseInboxes) => isUngated && hasAccess && inboxId === zorseInboxes.supportInboxId);